export const injectTypes = {
    projectContext: 'projectContext',
    navigationProjectContext: 'navigationProjectContext',
    userContext: 'userContext',
    loadUserContext: 'loadUserContext',
    applyFilters: 'applyFilters',
    refreshProjectContext: 'refreshProjectContext',
    adminNavigation: 'adminNavigation',
    sideNavRenderMode: 'sideNavRenderMode',
    loadAssetGroup: 'loadAssetGroup',
    // ViewProcessing
    startViewProcessing: 'startViewProcessing',
    stopViewProcessing: 'stopViewProcessing',
    withViewProcessing: 'withViewProcessing',
    isProcessingView: 'isProcessingView',
    // Adyen Payment Configuration
    adyenPaymentContext: 'adyenPaymentContext',
    // Project Performance Marketing
    performanceMarketingUserApiKey: 'performanceMarketingUserApiKey',
    performanceMarketingProjectContext: 'performanceMarketingProjectContext',
    performanceMarketingHasCatalogCampaigns: 'performanceMarketingHasCatalogCampaigns',
    modalBox: {
        withModalProcessing: 'withModalProcessing',
    },
    fieldId: 'fieldId',
    initializeProjectSetup: 'initializeProjectSetup',
};
